import React, { useEffect, useRef, useState } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface WYSIWYGProps {
    defaultValue: string;
    onChange: (value: string) => void;
}

const WYSIWYG: React.FC<WYSIWYGProps> = ({ defaultValue, onChange }) => {
    const [value, setValue] = useState(defaultValue);
    const quillRef = useRef<ReactQuill | null>(null);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const handleChange = (content: string) => {
        setValue(content);
        onChange(content);
    };

    const handleUndo = () => {
        // const editor = quillRef.current?.getEditor();
        // editor?.history.undo();
    };

    const handleRedo = () => {
        // const editor = quillRef.current?.getEditor();
        // editor?.history.redo();
    };

    const modules = {
        toolbar: {
            container: '#toolbar',
        },
        history: {
            delay: 1000,
            maxStack: 100,
            userOnly: true,
        },
    };

    const formats = [
        'bold', 'italic', 'underline', 'strike',
        'align',
        'indent',
        'list',
    ];

    return (
        <div className='form-builder-wysiwyg'>
            <div id="toolbar" className="flex flex-wrap items-center gap-2 wysiwyg-toolbar border p-2 rounded-md">
                <button onClick={handleUndo} type="button" className="px-1 hover:text-blue-500">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.15563 7.86706V10.2471C8.15563 10.7492 7.57001 11.0235 7.18428 10.702L3.23491 7.4109C2.95079 7.17414 2.95079 6.73776 3.23491 6.50099L7.18428 3.20985C7.57001 2.88841 8.15563 3.1627 8.15563 3.66481V6.04483H11.8001C13.7332 6.04483 15.5872 6.81277 16.9541 8.1797C18.321 9.54663 19.089 11.4006 19.089 13.3337C19.089 15.2669 18.321 17.1208 16.9541 18.4877C15.5872 19.8547 13.7332 20.6226 11.8001 20.6226H9.06674C8.56355 20.6226 8.15563 20.2147 8.15563 19.7115V19.7115C8.15563 19.2083 8.56355 18.8004 9.06674 18.8004H11.8001C13.2499 18.8004 14.6404 18.2244 15.6656 17.1992C16.6908 16.174 17.2667 14.7836 17.2667 13.3337C17.2667 11.8839 16.6908 10.4934 15.6656 9.46821C14.6404 8.44301 13.2499 7.86706 11.8001 7.86706H8.15563Z" fill="#52525B" />
                    </svg>


                </button>
                <button onClick={handleRedo} type="button" className="px-1 hover:text-blue-500">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.2444 7.86706H11.5999C10.1501 7.86706 8.75961 8.44301 7.73441 9.46821C6.70921 10.4934 6.13326 11.8839 6.13326 13.3337C6.13326 14.7836 6.70921 16.174 7.73441 17.1992C8.75961 18.2244 10.1501 18.8004 11.5999 18.8004H14.3333C14.8365 18.8004 15.2444 19.2083 15.2444 19.7115V19.7115C15.2444 20.2147 14.8365 20.6226 14.3333 20.6226H11.5999C9.66679 20.6226 7.81283 19.8547 6.4459 18.4877C5.07897 17.1208 4.31104 15.2669 4.31104 13.3337C4.31104 11.4006 5.07897 9.54663 6.4459 8.1797C7.81283 6.81277 9.66679 6.04483 11.5999 6.04483H15.2444V3.66481C15.2444 3.1627 15.83 2.88841 16.2157 3.20985L20.1651 6.50099C20.4492 6.73776 20.4492 7.17414 20.1651 7.4109L16.2157 10.702C15.83 11.0235 15.2444 10.7492 15.2444 10.2471V7.86706Z" fill="#52525B" />
                    </svg>

                </button>
                <span className="ql-formats me-0">
                    <button className="ql-bold" />
                    <button className="ql-italic" />
                    <button className="ql-underline" />
                    <button className="ql-strike" />
                </span>
                {/* <span className="ql-formats me-0">
                    <select className="ql-color" />
                    <select className="ql-background" />
                </span> */}
                {/* <span className="ql-formats me-0">
                    <select className="ql-align" />
                </span> */}
                <span className="ql-formats me-0">
                    <button className="ql-indent" value="-1" />
                    <button className="ql-indent" value="+1" />
                </span>
                <span className="ql-formats me-0">
                    <button className="ql-list" value="ordered" />
                    <button className="ql-list" value="bullet" />
                </span>
                {/* <button className="ql-clean" /> */}
            </div>

            <ReactQuill
                ref={quillRef}
                value={value}
                onChange={handleChange}
                theme="snow"
                modules={modules}
                formats={formats}
                className='wysiwyg'
                placeholder="Add a detailed concept so that brand can understand the whole idea"
            />
        </div>
    );
};

export default WYSIWYG;